// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from CalendarViewNavigation.module.scss  */
.CalendarViewNavigation-module-Root_16I {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem; }

.CalendarViewNavigation-module-NavigationButton_1vo {
  overflow: visible;
  margin: 0;
  padding: 0;
  cursor: pointer;
  color: var(--calendar-nav);
  border: none;
  background: transparent; }

.CalendarViewNavigation-module-NavigationDisplayYear_A10 {
  overflow: visible;
  margin: 0;
  padding: 0;
  font: inherit;
  cursor: pointer;
  border: none;
  background: transparent; }

.CalendarViewNavigation-module-SelectYearOptionsContainer_35t {
  position: absolute;
  z-index: 100;
  left: 50%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 0.4rem;
  padding: 0.1rem 0.2rem;
  border-radius: 8px;
  background-color: var(--calendar-select-year-background);
  transform: translateX(-50%);
  column-count: 3; }
  .CalendarViewNavigation-module-SelectYearOptionsContainer_35t::before {
    position: absolute;
    z-index: 100;
    top: -0.4rem;
    left: 50%;
    content: '';
    border-right: 0.4rem solid transparent;
    border-bottom: 0.4rem solid var(--calendar-select-year-background);
    border-left: 0.4rem solid transparent;
    transform: translateX(-50%); }

.CalendarViewNavigation-module-SelectYearOption_3ST {
  position: relative;
  display: flex;
  float: left;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 2.2rem;
  height: 1.4rem;
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
  cursor: pointer;
  text-align: center;
  color: var(--calendar-text-selected);
  border: none;
  background: transparent; }
  .CalendarViewNavigation-module-SelectYearOption_3ST:not(:nth-child(3n + 3)) {
    border-right: 1px solid var(--calendar-divider); }
  .CalendarViewNavigation-module-SelectYearOption_3ST:nth-last-child(n + 4) {
    border-bottom: 1px solid var(--calendar-divider); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Calendar/View/Navigation/CalendarViewNavigation.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe,EAAE;;AAEnB;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB,EAAE;;AAE3B;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB,EAAE;;AAE3B;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,wDAAwD;EACxD,2BAA2B;EAC3B,eAAe,EAAE;EACjB;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,WAAW;IACX,sCAAsC;IACtC,kEAAkE;IAClE,qCAAqC;IACrC,2BAA2B,EAAE;;AAEjC;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,uBAAuB,EAAE;EACzB;IACE,+CAA+C,EAAE;EACnD;IACE,gDAAgD,EAAE","sourcesContent":["/*  imported from CalendarViewNavigation.module.scss  */\n.CalendarViewNavigation-module-Root_16I {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.8rem; }\n\n.CalendarViewNavigation-module-NavigationButton_1vo {\n  overflow: visible;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  color: var(--calendar-nav);\n  border: none;\n  background: transparent; }\n\n.CalendarViewNavigation-module-NavigationDisplayYear_A10 {\n  overflow: visible;\n  margin: 0;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  border: none;\n  background: transparent; }\n\n.CalendarViewNavigation-module-SelectYearOptionsContainer_35t {\n  position: absolute;\n  z-index: 100;\n  left: 50%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin-top: 0.4rem;\n  padding: 0.1rem 0.2rem;\n  border-radius: 8px;\n  background-color: var(--calendar-select-year-background);\n  transform: translateX(-50%);\n  column-count: 3; }\n  .CalendarViewNavigation-module-SelectYearOptionsContainer_35t::before {\n    position: absolute;\n    z-index: 100;\n    top: -0.4rem;\n    left: 50%;\n    content: '';\n    border-right: 0.4rem solid transparent;\n    border-bottom: 0.4rem solid var(--calendar-select-year-background);\n    border-left: 0.4rem solid transparent;\n    transform: translateX(-50%); }\n\n.CalendarViewNavigation-module-SelectYearOption_3ST {\n  position: relative;\n  display: flex;\n  float: left;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  width: 2.2rem;\n  height: 1.4rem;\n  margin: 0;\n  padding: 0;\n  font-size: 0.8rem;\n  cursor: pointer;\n  text-align: center;\n  color: var(--calendar-text-selected);\n  border: none;\n  background: transparent; }\n  .CalendarViewNavigation-module-SelectYearOption_3ST:not(:nth-child(3n + 3)) {\n    border-right: 1px solid var(--calendar-divider); }\n  .CalendarViewNavigation-module-SelectYearOption_3ST:nth-last-child(n + 4) {\n    border-bottom: 1px solid var(--calendar-divider); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
